export default __webpack_public_path__ + "static/media/25year.2a20043a.svg";